import { defineMessages } from 'react-intl';
import { SportTermLookup, SportTerminology } from '../../../lib/types';

export const scope = 'app.components.ImportSessions';

// {noun} is filled by the pluralize helper so the count word agrees without ICU plural
// syntax — file rows on the err* lines, the sport's session term on the snack* summaries.
export const getImportSessionsMessages = (termLookup: SportTermLookup) => {
  const session = termLookup[SportTerminology.SESSION].toLowerCase();

  return defineMessages({
    snackCreated: {
      id: `${scope}.snackCreated`,
      defaultMessage: '{count} {noun} added to this assessment.',
    },
    snackAgeGroupsCreated: {
      id: `${scope}.snackAgeGroupsCreated`,
      defaultMessage: '{count} new age {noun} created.',
    },
    errSkipped: {
      id: `${scope}.errSkipped`,
      defaultMessage: '{count} {noun} left out of the import because required details were missing or invalid. Correct them in your file and import again.',
    },
    errImportFailed: {
      id: `${scope}.errImportFailed`,
      defaultMessage: `Couldn't import your ${session} file. Please try again.`,
    },
    // {names} is the age groups the server refused, named where the file's own groups
    // still exist; {noun} agrees with how many, via the pluralize helper.
    errInaccessibleAgeGroups: {
      id: `${scope}.errInaccessibleAgeGroups`,
      defaultMessage: `Nothing was imported: {names} {verb} no longer available to you. Remove {noun} from your file and import again.`,
    },
    // {link} is the template download link, labelled by templateLink.
    templatePrompt: {
      id: `${scope}.templatePrompt`,
      defaultMessage: 'Use your own CSV or start with this template: {link}',
    },
    templateLink: {
      id: `${scope}.templateLink`,
      defaultMessage: `Master ${termLookup[SportTerminology.SESSION]} Import Template`,
    },
    columnOrderNote: {
      id: `${scope}.columnOrderNote`,
      defaultMessage: 'Column order is not enforced. Next steps will match columns to the appropriate field',
    },
  });
};
